import { Box, Image as ChakraImage } from "@chakra-ui/react";

export type ImageProps = {
  src: string;
  width: number;
  height: number;
  alt?: string;
};

const Image = ({ src, height, width, alt }: ImageProps) => {
  return (
    <Box>
      <ChakraImage
        mx={"auto"}
        alt={alt || "content image"}
        src={src}
        width={width ? `${width}` : "100%"}
        height={height ? `${height}` : "10rem"}
      />
    </Box>
  );
};

export default Image;
